/**
 * Created by Languagenut on 22/03/2019.
 */


import React  from 'react';
import {Card , Button, Badge, Modal, Row, Col, ProgressBar} from 'react-bootstrap'
import {ClassesService, UserService, AccountService, ProductService} from '../services';
import {ClassesStore, ProductStore} from '../store';
import Constants from '../constants.js';
import GeneratePDF from '../classes/pdf_generate.js'
import Comfirmation from '../components/popup/comfirmation_popup.js';
import Translation from '../store/internationalization-store.js';
import GeneralTable from '../components/general_table.js';
import Popup from '../components/popup/comfirmation_popup.js'
import FieldGroup from '../components/FieldGroup.js';
import Select from  'react-select';
import LicenseImport from '../components/popup/license_import.js'

export default class StudentManagement extends React.Component {
 
    constructor(props) {
        super();
        this.props = props;
        this.state = {
            tab:"students",
            toggle:false,
            loading:true,
            lastSelected:undefined
        };
    }

    returnEmojiKey(emojiData){
        return <span class="notSelect" onClick={function() {
            if ( this.state.lastSelected == undefined) {
                return;
            }
            var $txt = this.state.lastSelected;
            var caretPos = $txt.selectionStart;
            if (this.state.lastSelectType == "title") {
                var textAreaTxt = this.state.messageTitle;
                var newTextValue = textAreaTxt.substring(0, caretPos) + emojiData + textAreaTxt.substring(caretPos);
                this.setState({messageTitle:newTextValue});
            } else {
                var textAreaTxt = this.state.messageMessage;
                var newTextValue = textAreaTxt.substring(0, caretPos) + emojiData + textAreaTxt.substring(caretPos);
                this.setState({messageMessage:newTextValue});
            }
        }.bind(this)} style={{fontSize:"30px"}}>{emojiData}</span>
    }

    updateData() {

    }

    componentWillMount(){
        ClassesStore.on(Constants.GET_STUDENTS , () =>{
            this.setState({
                students:ClassesStore.students || [],
                loading:false,
            })

        })
        ProductStore.on(Constants.GET_USER_DATA,  ()=>{
            this.setState({updated:true})
        })
    }

    componentDidMount(){
        ClassesService.getStudentsAll();
        ProductService.getUserData();
    }

    handleSelect(eventKey){
        this.setState({tab:eventKey})
    }

    onClick(){
        this.setState({
            toggle:!this.state.toggle,
        })
    }

    getBody()
    {
        switch(this.state.tab)
        {
            case "students" : return <h4>Students</h4>
            case "staff" : return <h4>Students</h4>
        }
    }

    handleDownload(userName, limit){
        this.PDFgen = new GeneratePDF();
        this.PDFgen.generateOxfordLicencesPDF(this.state.students, userName, limit);
    }

    renderProfileLink(cell, row){
        return {cell}
    }

    percentage(){
        return <span>0%</span>
    }


    getHeader(title){

        switch(title)
        {
            case "name" : return Translation.get(827 , 'Student Name');
            case "username" : return Translation.get(22 , 'Username');
            case "password" : return Translation.get(23 , 'Password');
            case "uid" : return Translation.get(0 , 'Password / Login ID');
            case "vocabLearnt" : return Translation.get(12605 , 'Vocabulary Learnt');
            case "verbLearnt" : return Translation.get(12193 , 'Verbs Learnt');
            case "grammarLearnt" : return Translation.get(12602, 'Grammar Units Learnt');
            case "sentenceLearnt" : return Translation.get(12194 , 'Sentences Learnt');
            case "goldMedals" : return Translation.get(12619 , 'Gold Medals');
            case "silverMedals" : return Translation.get(12620 , 'Silver Medals');
            case "bronzeMedals" : return Translation.get(12621 , 'Bronze Medals');
            case "totalScore" : return Translation.get(12622 , 'World Score');
            case "rank" : return Translation.get(37 , 'World Ranking');
            case "examsCompleted" : return Translation.get(12042 , 'Exam Skills');
            case "last_login" : return Translation.get(13 , 'Login');
            case "rankingScore" : return Translation.get(268 , 'Points');
            case "classes" : return Translation.get(830 , 'Classes');
        }

        return title
    }

    getPostition(title){

        switch(title)
        {
            case "name" : return 0;
            case "uid" : return 1;
            case "classes" : return 5;
            case "last_login" : return 3;
            case "rankingScore" : return 4;
            case "username" : return 1;
            case "password" : return 2;
        }

        return 0;
    }


    isSort(title){

        switch(title)
        {
            case "username" : return false
            case "password" : return false
            case "name" : return false
            case "classes" : return false
        }

        return true
    }

    getCsvFormatter(uid) {

        if (uid == 'classes') {
            return function(cell , row) {
                var data = "";
                for (var i = 0; i < cell.length; i++) {
                    data += cell[i].name;
                    data += ", ";
                }
                return data;
            }
        }
        return function(cell , row) {

            if(!cell) return 0;
            return cell;
        }
    }

    getFormatter(uid) {

        if (uid == 'classes') {
            return function(cell, row) {
                var endData = [];
                if (cell.length == undefined) {
                    return endData;
                }
                for (var i =0; i < cell.length; i++) {
                    endData.push(<Badge style={{marginLeft:'5px'}}variant="primary" >{cell[i].name}</Badge>);
                }
                return endData;
            } 
        }
        return (cell)=>{

            if(!cell) return 0;
            return cell;
        }
    }

    resources(username){
        if  (window.location.href.indexOf("gamma") > -1) {
            window.open('https://gamma.languagenut.com/resources/#/LoginScreen?username='+username,'_blank');
        } else if (window.location.href.indexOf(".cn") > -1) {
            window.open('https://languagenut.cn/resources/#/LoginScreen?username='+username,'_blank');
        }  else if (window.location.href.indexOf("asia") > -1) {
            window.open('https://asia.languagenut.com/resources/#/LoginScreen?username='+username,'_blank');
        } else {
            window.open('https://languagenut.com/resources/#/LoginScreen?username='+username,'_blank');
        }
    }

    getCols(){
        return [
            {
                dataField: 'uid',
                text:  'Login ID',
                sortable:true,
                searchable: true,
            },{
                dataField: 'createdBy',
                text:  'Created by',
                searchable: true,
                sortable:true
            },{
                dataField: 'emailCreatedBy',
                text:  'Email address',
                searchable: true
            },{
                dataField: 'created',
                text:  'Created Date',
                searchable: true,
                sortable:true,
                sort:true,
                sortFunc: (a, b, order, dataField, rowA, rowB) => {
                    var arr = a.split('/');
                    a = new Date(arr[2], arr[1] - 1, arr[0]);
                    var arr = b.split('/');
                    b = new Date(arr[2], arr[1] - 1, arr[0]);
                    if (order === 'asc') {
                        if (a < b) {
                            return -1
                        } else {
                            return 1
                        }
                    }
                    if (a > b) {
                        return -1
                    } else {
                        return 1
                    }
                }
            },
        ]
    }

    goTo(){
        window.location.hash = 'settings/importer_classes';
    }

    getUserName() {
        if (ProductStore.userData == undefined || ProductStore.userData.accountSettings == undefined 
            || ProductStore.userData.accountSettings['cefrUsername'] == undefined) {
            return "N/A";
        }
        return ProductStore.userData.accountSettings['cefrUsername'];
    }

    render(){

        if(this.state.loading) return <ProgressBar animated now={45} />
        
        if (!this.state.students) {
            return "";
        }

        var adminData = "";

        if (ProductStore.userData != undefined) {
            var username = this.getUserName();

            if (username != ""){
                adminData =<span style={{paddingRight:"20px"}}><b>Test username:</b> {username}</span>
            }
        }

        var generateOptions = [{value: 'af' ,label:""}];

        for (var i = 5; i < this.state.students.length; i += 5) {
            generateOptions .push({value: i ,label:i});
        }
        generateOptions .push({value: this.state.students.length ,label:this.state.students.length});

        var popup3 = <Popup oneButton={true} buttonTitle={Translation.get(0, "Download")} title={"Download Logins"} 
        onSave={()=>{
            this.handleDownload(username, this.state.numberOfDownloads.value);
            this.setState({downloadLoginsMessge:false});
        }} 
        onHide={()=>{
            this.setState({downloadLoginsMessge:false});
        }} 
        show={this.state.downloadLoginsMessge} 
        body={<div>
                <Row >
                    <Col sm={{span: 12}}>You currently have {this.state.students.length} licences. How many licences do you want to download?</Col>
                </Row>
                <br></br>
                <Row >
                    <Col sm={{span: 12}}>
                        <Select value={this.state.numberOfDownloads}
                                    onChange={function(length) {this.setState({numberOfDownloads:length})}.bind(this)}
                                    options={generateOptions}
                                />
                    </Col>
                </Row>
            </div>} />

var defaultSorted = [{
    dataField: 'uid', // if dataField is not match to any column you defined, it will be ignored.
    order: 'desc' // desc or asc
  }];        

var buttonMessageAll = "";
        if (ProductStore.getUserData().userType != "school" && ProductStore.getUserData().userType != "admin") {
            buttonMessageAll = ""
        }
        buttonMessageAll = [adminData,<Button style={{marginRight:"10px"}} onClick={function() {
            this.setState({downloadLoginsMessge:true})
        }.bind(this)}>{Translation.get(0 , 'Student Logins')}</Button>,<Button style={{marginRight:"10px"}} onClick={function() {
            this.resources(username)
        }.bind(this)}>{Translation.get(0 , 'Test Url')}</Button>,<Button onClick={()=>{this.setState({import:true})}}>{Translation.get(0 , 'Add Licenses')}</Button>];


        return <Card body>
            {popup3}
            <Comfirmation onSave={function() {
                ClassesService.deleteStudent(this.state.deletedStudent).then(function(){
                        ClassesService.getStudentsAll();
                    }.bind(this))
                }.bind(this)} body={Translation.get(12623 , 'Are you sure you want to delete this student?')} 
                    onHide={()=>{this.setState({action:""})}} show={this.state.action == 'deleteStudent'} />
            <div>
            <LicenseImport show={this.state.import} onHide={()=>{ ClassesService.getStudentsAll(); this.setState({import:false})}} />
            <GeneralTable component={buttonMessageAll} pageSize={40}

                          defaultSorted={ defaultSorted }  bordered={ true } keyField='id' data={ this.state.students || [] } columns={ this.getCols() } />
            </div>
        </Card>
    }
}